export const WIDGET_STYLE = {
    DEV: 'dev',
    WEBSITE: 'website',
    SIDE: 'side',
    INLINE: 'inline',
};
